import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { getRoleFallbackPath } from '@/config/routeAccess'

/** `/` — um único redirect por papel (evita montar Dashboard sem permissão). */
export function HomeRoute() {
  const { isAuthenticated, user, token, sessionUsesCookie } = useAuthStore()

  if (!isAuthenticated || !user || (!token && !sessionUsesCookie)) {
    return <Navigate to='/login' replace />
  }

  return <Navigate to={getRoleFallbackPath(user.role, undefined, user)} replace />
}
